import { defineStore } from "pinia";
import { Configuration } from "../models/configuration.model";

export const useConfigStore = defineStore('configuration', {
    state: () => (<Configuration>{
        loaded: false,
        clientId: null,
        clientSecret: null,
        environment: 'dev',
        apiEndpoint: null,
        jwtEndpoint: null,
        socketEndpoint: null,
        VERSION: null,
    }),

    actions: {
        load(): void {
            const settings: string = document.getElementById('settings')?.textContent || '';
            try {
                this.$state = { ...this.$state, ...JSON.parse(settings) };
                this.loaded = true;
            } catch(e) {
                console.error('Could not load configuration. Something went wrong');
            }
        }
    }
});